var map = {
	"./allResource": 926,
	"./allResource.js": 926,
	"./collection": 927,
	"./collection.js": 927,
	"./personalResources": 928,
	"./personalResources.js": 928,
	"./publishResource": 929,
	"./publishResource.js": 929,
	"./unitResources": 930,
	"./unitResources.js": 930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3253;